import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Paper from "@mui/material/Paper";
import { ActionPlansContext } from "context/ActionPlansContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { putActionPlan, getActionPlan } from "services/ConfigServices";
import { getSite } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import SubmitButton from "components/CustomButtons/SubmitButton";
import EditButton from "components/CustomButtons/EditButton";
import { planActions } from "variables/planActions";
import { energyType } from "variables/lists/action";
import { refConsumptionSourceData } from "variables/lists/planActions";

export default function ReferenceEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;

  console.log(actionPlans);

  const [newReference, setNewReference] = useState();
  console.log(newReference);

  const handleChange = (e, reference) => {
    const { name, value } = e.target;
    console.log(name, value, reference);
    setNewReference((prevState) => ({
      ...prevState,
      [params]: {
        ...prevState.reference,
        [reference]: { ...prevState.reference?.[reference], [name]: value },
      },
    }));
  };

  const handleRefConsumptionSourceChange = (e) => {
    const { name, value } = e.target;
    setNewReference((prevState) => ({
      ...prevState,
      [params]: {
        ...prevState.reference,
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    //setNewReference({ actionplan: actionPlans.id });
    console.log("actionPlans");
    setNewReference(actionPlans?.parameters || {});
  }, [actionPlans]);

  const urlPlanAction = getActionPlan(actionPlans.id);

  let url = putActionPlan(actionPlans.id);

  const handleSubmit = (event) => {
    createActionReference(event);
  };

  const getRefConsumptionSource = async (event) => {
    if (newReference?.[params]?.["refConsumptionSource"] === "patrimoine") {
      getPatrimoineData();
    }
    if (newReference?.[params]?.["refConsumptionSource"] === "tertiaryBill") {
      getTertiaryBillData();
    }
  };

  const getPatrimoineData = async (event) => {
    let data = [];
    for (let energy of energyType) {
      await axios
        .get(
          getSite(
            actionPlans.parameters.general.groups[0],
            "energy." + energy + "." + "reference"
          ),
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((response) => {
          data.push(response.data.detail.energy || { [energy]: {} });
        });
    }
    console.log(data);
    pushPatrimoineInNewReference(data);
  };

  const getTertiaryBillData = (event) => {
    axios
      .get(getSite(actionPlans.parameters.general.groups[0], "tertiarybill"), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data.detail.tertiarybill);
        pushTertiaryInNewReference(response.data.detail.tertiarybill || {});
      });
  };

  async function pushPatrimoineInNewReference(arr1) {
    let referenceData = {
      ...newReference,
      reference: { ...newReference?.reference },
    };
    let referenceValue = "";
    let referenceDate = "";

    await arr1.map((energy) => {
      let energySelected = Object.keys(energy)[0];
      console.log(energySelected);
      referenceValue = energy[energySelected]?.reference?.referencefinalenergy;
      referenceDate = energy[energySelected]?.reference?.referenceyear;

      referenceData.reference[energySelected + "refconsumption"] = {
        value: referenceValue,
        date: referenceDate,
      };
    });

    console.log(referenceData);

    setNewReference(referenceData);
  }

  function pushTertiaryInNewReference(object1) {
    let referenceData = {
      ...newReference,
      reference: { ...newReference?.reference },
    };
    let startdate = object1?.startdate || "";
    for (const [key, value] of Object.entries(object1)) {
      console.log(`${key}: ${value}`);

      if (
        [
          "electricityrefconsumption",
          "gasrefconsumption",
          "fuelrefconsumption",
        ].includes(key)
      ) {
        referenceData.reference[key] = { value: value, date: startdate };
      } else if (key === "propanekgrefconsumption") {
        referenceData.reference.propanerefconsumption = {
          value: value,
          date: startdate,
        };
      } else if (key === "heatnetworkrefconsumption") {
        referenceData.reference.heatrefconsumption = {
          value: value,
          date: startdate,
        };
      } else if (key === "coldnetworkrefconsumption") {
        referenceData.reference.coldrefconsumption = {
          value: value,
          date: startdate,
        };
      }
    }

    console.log(referenceData);
    setNewReference(referenceData);
  }

  const createActionReference = async (event) => {
    axios
      .put(url, newReference, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setActionPlans((prevState) => ({
            ...prevState,
            parameters: newReference,
          }));
          setNotification("success", "Référence modifiée");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={8} lg={8}>
          <CustomSelect
            inputTitle={planActions[params]["refConsumptionSource"]}
            selectValue={newReference?.[params]?.["refConsumptionSource"] || ""}
            handleSelectValueChange={handleRefConsumptionSourceChange}
            data={refConsumptionSourceData}
            name="refConsumptionSource"
            disabled={!actionplanadmin}
          />
        </GridItem>
        {actionplanadmin && (
          <GridItem
            xs={12}
            sm={12}
            md={4}
            lg={4}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {newReference?.[params]?.["refConsumptionSource"] !== "manual" && (
              <SubmitButton handleSubmit={getRefConsumptionSource}>
                Préremplir
              </SubmitButton>
            )}
          </GridItem>
        )}
      </GridContainer>
      <GridContainer>
        {energyType.map((energy) => {
          let reference = energy + "refconsumption";
          return (
            <>

                <GridItem xs={12} sm={12} md={8} lg={8}>
                  <FloatInput
                    inputTitle={planActions[params][reference]}
                    floatInput={
                      newReference?.[params]?.[reference]?.value || ""
                    }
                    handleFloatInputChange={(e) => handleChange(e, reference)}
                    name={"value"}
                    disabled={!actionplanadmin}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <DateInput
                    dateInput={
                      newReference?.[params]?.[reference]?.date || ""
                    }
                    handleDateInputChange={(e) => handleChange(e, reference)}
                    specialType={"month"}
                    name="date"
                    disabled={!actionplanadmin}
                  />
                </GridItem>
            </>
          );

        })}
        {actionplanadmin && (
          <GridItem
            xs={12}
            sm={6}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        )}
      </GridContainer>
    </>
  );
}
